import { RelationshipsCard } from './RelationshipsCard';
import useAsync from 'react-use/lib/useAsync';
import { usedByEntitiesList, usingEntitiesList } from './common';
import { catalogApiRef, useEntity } from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/core-plugin-api';
import { Entity } from '@backstage/catalog-model';

// This card provides two subcards to show the dependencies and dependents of this component
// By default backstage will show connections but these are comsumption between APIs
// It is not so nice to see you have an API then click to see components.

export const ServiceRelationshipsCard = () => {
  const catalogApi = useApi(catalogApiRef);
  const { entity } = useEntity();

  const { value, loading } = useAsync(async () => {
    const usedBy = await usedByEntitiesList(catalogApi, entity);
    const using = await usingEntitiesList(catalogApi, entity);

    return {
      usedBy,
      using,
    };
  }, [entity]);

  /* Nothing to render, why waste it */
  if (loading) return null;

  const usedBy = value?.usedBy as Entity[];
  const using = value?.using as Entity[];

  return <RelationshipsCard usedBy={usedBy} using={using} />;
};
